import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [{
  path: '/:lang(en|ar|es)?',
  component: {
    template: '<router-view />'
  },
  children: [
    {
      path: '',
      redirect: 'Welcome'
    },
    {
      path: 'Welcome',
      name: 'Welcome',
      component: () => import('../views/Welcome.vue')
    },
    {
      path: 'Locations',
      name: 'Locations',
      component: () => import('../views/Locations.vue')
    },
    {
      path: 'InitialRequirements',
      name: 'InitialRequirements',
      component: () => import('../views/InitialRequirements.vue')
    },
    {
      path: 'IncomeRange',
      name: 'IncomeRange',
      component: () => import('../views/IncomeRange.vue')
    },
    {
      path: 'MatchHeadstart',
      name: 'MatchHeadstart',
      component: () => import('../views/MatchHeadstart.vue')
    },
    {
      path: 'MatchHeadstartReferral',
      name: 'MatchHeadstartReferral',
      component: () => import('../views/MatchHeadstartReferral.vue')
    },
    {
      path: 'MatchHeadstartAndHSGSRPLikelyReferral',
      name: 'MatchHeadstartAndHSGSRPLikelyReferral',
      component: () => import('../views/MatchHeadstartAndHSGSRPLikelyReferral.vue')
    },    
    {
      path: 'MatchHSGSRPLikelyReferral',
      name: 'MatchHSGSRPLikelyReferral',
      component: () => import('../views/MatchHSGSRPLikelyReferral.vue')
    },       
    {
      path: 'AlternateHSQualifier',
      name: 'AlternateHSQualifier',
      component: () => import('../views/AlternateHSQualifier.vue')
    },
    {
      path: 'AlternateHSQualifierList2',
      name: 'AlternateHSQualifierList2',
      component: () => import('../views/AlternateHSQualifierList2.vue')
    },
    {
      path: 'AlternateHSQualifierList3',
      name: 'AlternateHSQualifierList3',
      component: () => import('../views/AlternateHSQualifierList3.vue')
    },
    {
      path: 'AlternateHSQualifierUnder4',
      name: 'AlternateHSQualifierUnder4',
      component: () => import('../views/AlternateHSQualifierUnder4.vue')
    },
    {
      path: 'AlternateHSQualifierUnder4List2',
      name: 'AlternateHSQualifierUnder4List2',
      component: () => import('../views/AlternateHSQualifierUnder4List2.vue')
    },    
    {
      path: 'AlternateHSQualifierUnder4List3',
      name: 'AlternateHSQualifierUnder4List3',
      component: () => import('../views/AlternateHSQualifierUnder4List3.vue')
    },    
    {
      path: 'AlternateGSRPQualifier',
      name: 'AlternateGSRPQualifier',
      component: () => import('../views/AlternateGSRPQualifier.vue')
    },
    {
      path: 'AlternateGSRPQualifierList2',
      name: 'AlternateGSRPQualifierList2',
      component: () => import('../views/AlternateGSRPQualifierList2.vue')
    },
    {
      path: 'SorryNotArea',
      name: 'SorryNotArea',
      component: () => import('../views/SorryNotArea.vue')
    },
    {
      path: 'MatchNone',
      name: 'MatchNone',
      component: () => import('../views/MatchNone.vue')
    },
    {
      path: 'MatchGSRP',
      name: 'MatchGSRP',
      component: () => import('../views/MatchGSRP.vue')
    },
    {
      path: 'MatchGSRPReferral',
      name: 'MatchGSRPReferral',
      component: () => import('../views/MatchGSRPReferral.vue')
    },    
    {
      path: 'MatchGSRPLikelyReferral',
      name: 'MatchGSRPLikelyReferral',
      component: () => import('../views/MatchGSRPLikelyReferral.vue')
    },    
    {
      path: 'MatchNoneAndGSRP',
      name: 'MatchNoneAndGSRP',
      component: () => import('../views/MatchNoneAndGSRP.vue')
    },
    {
      path: 'MatchNoneAndGSRPReferral',
      name: 'MatchNoneAndGSRPReferral',
      component: () => import('../views/MatchNoneAndGSRPReferral.vue')
    },
    {
      path: 'MatchNoneAndGSRPLikelyReferral',
      name: 'MatchNoneAndGSRPLikelyReferral',
      component: () => import('../views/MatchNoneAndGSRPLikelyReferral.vue')
    },
    {
      path: 'StartApplication',
      name: 'StartApplication',
      component: () => import('../views/StartApplication.vue')
    },
    {
      path: 'StartApplicationPickPrograms',
      name: 'StartApplicationPickPrograms',
      component: () => import('../views/StartApplicationPickPrograms.vue')
    },
    {
      path: 'MatchHSAndGSRP',
      name: 'MatchHSAndGSRP',
      component: () => import('../views/MatchHSAndGSRP.vue')
    },
    {
      path: 'MatchHSAndGSRPReferral',
      name: 'MatchHSAndGSRPReferral',
      component: () => import('../views/MatchHSAndGSRPReferral.vue')
    },    
    {
      path: 'MatchNoneCDCLikelyAndGSRP',
      name: 'MatchNoneCDCLikelyAndGSRP',
      component: () => import('../views/MatchNoneCDCLikelyAndGSRP.vue')
    },
    {
      path: 'MatchNoneCDCLikelyAndGSRPReferral',
      name: 'MatchNoneCDCLikelyAndGSRPReferral',
      component: () => import('../views/MatchNoneCDCLikelyAndGSRPReferral.vue')
    },
    {
      path: 'GSRPPickPrograms',
      name: 'GSRPPickPrograms',
      component: () => import('../views/GSRPPickPrograms.vue')
    },
    {
      path: 'MatchNoneCDC',
      name: 'MatchNoneCDC',
      component: () => import('../views/MatchNoneCDC.vue')
    },
    {
      path: 'PreviouslyAppliedHS',
      name: 'PreviouslyAppliedHS',
      component: () => import('../views/PreviouslyAppliedHS.vue')
    },
    {
      path: 'HeadstartPickPrograms',
      name: 'HeadstartPickPrograms',
      component: () => import('../views/HeadstartPickPrograms.vue')
    },
    {
      path: 'CareGiver1',
      name: 'CareGiver1',
      component: () => import('../views/common-forms/CareGiver1.vue')
    },
    {
      path: 'CareGiver2',
      name: 'CareGiver2',
      component: () => import('../views/common-forms/CareGiver2.vue')
    },
    {
      path: 'CareGiver3',
      name: 'CareGiver3',
      component: () => import('../views/common-forms/CareGiver3.vue')
    },
    {
      path: 'Child1',
      name: 'Child1',
      component: () => import('../views/common-forms/Child1.vue')
    },
    {
      path: 'Child2/:index',
      name: 'Child2',
      component: () => import('../views/common-forms/Child2.vue')
    },
    {
      path: 'FinalDetails',
      name: 'FinalDetails',
      component: () => import('../views/common-forms/FinalDetails.vue')
    },
    {
      path: 'FinalDetails2',
      name: 'FinalDetails2',
      component: () => import('../views/common-forms/FinalDetails2.vue')
    },
    {
      path: 'FinalDetailsEligibility',
      name: 'FinalDetailsEligibility',
      component: () => import('../views/FinalDetailsEligibility.vue')
    },
    {
      path: 'HouseholdInformation',
      name: 'HouseholdInformation',
      component: () => import('../views/common-forms/HouseholdInformation.vue')
    },
    {
      path: 'ThankYou',
      name: 'ThankYou',
      component: () => import('../views/common-forms/ThankYou.vue')
    },
    {
      path: 'Download/:token',
      name: 'Download',
      component: () => import('../views/secure/Download.vue')
    },
    {
      path: 'Followup211/:token',
      name: 'Followup211',
      component: () => import('../views/secure/Followup211.vue')
    },
    {
      path: 'FeedbackFollowup/:token',
      name: 'FeedbackFollowup',
      component: () => import('../views/secure/FeedbackFollowup.vue')
    },
    {
      path: 'Ready4k/:token',
      name: 'Ready4k',
      component: () => import('../views/secure/Ready4k.vue')
    },
    {
      path: 'FeedbackRaffle/:token',
      name: 'FeedbackRaffle',
      component: () => import('../views/secure/FeedbackRaffle.vue')
    },
    {
      path: 'Feedback',
      name: 'Feedback',
      component: () => import('../views/feedback/Feedback.vue')
    },
    {
      path: 'FeedbackResponse',
      name: 'FeedbackResponse',
      component: () => import('../views/feedback/FeedbackResponse.vue')
    },
    {
      path: 'Parent/:token',
      name: 'Parent',
      component: () => import('../views/Parent.vue')
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: () => import('../views/SorryPageNotFound.vue')
    }]
}]

export default routes
